import React from "react";
import { GET_LIST, Link } from "react-admin";
import { Card, CardContent, Button, CardHeader } from "@material-ui/core";
import dataProviderFactory from "../dataProvider";
import moment from "moment";
import styled from "styled-components";
import MonetizationOn from "@material-ui/icons/MonetizationOn";
import Warning from "@material-ui/icons/Warning";
import RentalPopOver from "./rentalPopOver";
import {
  map,
  curry,
  filter,
  isNil,
  assoc,
  propEq,
  find,
  range,
  when,
  complement,
  prop,
  sortBy,
  sortWith,
  ascend,
  path,
  head,
  uniq,
  indexOf,
} from "ramda";
import * as R from "ramda";
import LinearProgress from "@material-ui/core/LinearProgress";
import BikeInformationButton from "./bikeInformation";
import { parse } from "query-string";
import ArrowUpward from "@material-ui/icons/ArrowUpward";

const StyledMonetizationOn = styled(MonetizationOn)`
  height: 18px !important;
`;

const StyledError = styled(Warning)`
  height: 18px !important;
`;

const StyledLink = styled(Link)`
  :link {
    color: #000000;
    text-decoration: underline;
  }
  :visited {
    color: #000000;
  }
  :hover {
    color: #000000;
  }
  :active {
    color: #000000;
  }
`;

const Grid = styled.div({
  display: "flex",
  flexDirection: "row",
  flexGrow: 1,
  maxWidth: "82vw",
  justifyContent: "flext-start"
});

const SpanRented = styled.span({
  color: "red",
  fontSize: "13px",
  fontWeight: "bolder"
});

const View = styled.span(props => ({
  color: props.color || "initial",
  fontWeight: props.weight || "normal",
  padding: "2px",
  backgroundColor: props.background,
  display: "inline-block",
  backgroundImage: props.shade
    ? "url(data:image/gif;base64,R0lGODlhDAAMAIAAAP///wAAACH5BAEAAAAALAAAAAAMAAwAAAIUhI8QmcvnnpImPstwo5Nq9EEcUAAAOw==)"
    : "none"
}));

const MainView = styled(View)(props => ({
  marginRight: "2px",
  flexGrow: 1,
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
}));
const AuxView = styled(View)(props => ({
  minWidth: props.small ? "15%" : "29%",
  padding: "0px",
  display: "flex",
  justifyContent: "space-around",
  alignItems: "center"
}));

const Table = styled.div({
  display: "flex",
  overflow: "scroll",
  width: "90vw"
});

const KmSpan = styled.span({
  fontSize: "12px",
  fontWeight: "900",
  textDecoration: "underline",
  color: "red",
  backgroundColor: "white"
});

const Cell = props => {
  const {
    textValue,
    secundaryTextValue,
    color,
    secundaryColor,
    textColor,
    textWeight,
    weekend,
    smallAux,
    children,
    extraText,
    style
  } = props;
  return (
    <React.Fragment>
      <MainView
        background={color}
        color={textColor}
        weight={textWeight}
        shade={weekend}
        style={style}
      >
        {" "}
        {textValue} {children}&nbsp;<KmSpan>{extraText}</KmSpan>
      </MainView>
      <AuxView
        background={secundaryColor || color}
        shade={weekend}
        small={smallAux}
        style={style}
      >
        {" "}
        {secundaryTextValue}{" "}
      </AuxView>
    </React.Fragment>
  );
};

const DateColumn = styled.div(props => ({
  display: "flex",
  flexDirection: "column",
  backgroundColor: props.color,
  border: "1px solid #ffffff"
}));

const Column = styled.div(props => ({
  display: "flex",
  flexDirection: "column",
  backgroundColor: props.color,
  border: "1px solid #ffffff",
  minWidth: "15rem",
  fontSize: "13px"
}));

const WeekDay = styled.div({
  width: "5.5rem"
});
const Date = styled.div({
  width: "7rem"
});

const Row = styled.div({
  display: "flex",
  height: "1.5rem",
  flexWrap: "nowrap",
  marginBottom: "2px",
  marginRight: "5px"
});

const BackButton = styled.div({
  marginBottom: "1rem"
});

const nilMap = R.when(R.complement(R.isNil));

const isWeekend = day => day.isoWeekday() === 6 || day.isoWeekday() === 7;

const duration = (rental) => {
  let days = moment(rental.date_2).diff(rental.date_1, 'days')
  if (rental.time_1 === '10:00:00' && rental.time_2 === '18:00:00') {
    days += 1
  } else if (rental.time_1 === '18:00:00' && rental.time_2 === '10:00:00') {
    days -= 1
  }
  return days || 0
}

const DISTANT_PAST = 0;
const DISTANT_FUTURE = 1e15;
let valorC = null

class VansSchedule extends React.Component {
  async getModels() {
    const dataProvider = await dataProviderFactory("rest");
    const models = await dataProvider(GET_LIST, "vehicle_models", {
      filter: { active: true },
      pagination: {
        page: 1,
        perPage: 99999
      },
      sort: { field: "order", order: "ASC" }
    });
    return models.data;
  }

  SetDate = (param) => {
    this.setState({
      dateV: moment(Date.parse(param)).format("YYYY-MM-DD")
    })
  }


  async getLocations() {
    const dataProvider = await dataProviderFactory("rest");
    const locations = await dataProvider(GET_LIST, "locations", {
      filter: { only_bases: "true" },
      pagination: {
        page: 1,
        perPage: 999
      },
      sort: { field: this.props.created_at, order: "DESC" }
    });
    return locations;
  }

  async getHolidays(startDate, endDate, location) {
    const dataProvider = await dataProviderFactory("rest");
    const holidays = dataProvider(GET_LIST, "holidays", {
      filter: {
        startDate: startDate.format("YYYY-MM-DD"),
        endDate: endDate.format("YYYY-MM-DD"),
        location_id: location
      },

      pagination: {
        page: 1,
        perPage: 99999
      },
      sort: { field: this.props.created_at, order: "DESC" }
    });

    return holidays;
  }

  async fetchData(startDate, endDate, location, model) {
    const dataProvider = await dataProviderFactory("rest");
    const getDisplacedVehicles = dataProvider(GET_LIST, "displaced_vehicles", {
      filter: {},
      pagination: {
        page: 1,
        perPage: 99999
      },
      sort: { field: this.props.created_at, order: "DESC" }
    });
    const getItemLocations = dataProvider(GET_LIST, "item_locations", {
      filter: {
        type: "vehicle",
        endDate: moment(endDate).format("YYYYMMDD"),
        date: moment(startDate)
          .format("YYYYMMDD")
      },
      pagination: {
        page: 1,
        perPage: 99999
      },
      sort: { field: this.props.created_at, order: "DESC" }
    });

    const getVehicles = await dataProvider(GET_LIST, "bike_schedule", {
      filter: {
        schedule: true,
        include_events_start: startDate.format("YYYYMMDD"),
        include_events_end: endDate.format("YYYYMMDD"),
        vehicle_model_id: model
      },
      pagination: {
        page: 1,
        perPage: 9999
      },
      sort: {}
    });

    const [
      vehicles,
      locations,
      itemLocations,
      displacedVehicles
    ] = await Promise.all([
      getVehicles,
      this.getLocations(),
      getItemLocations,
      getDisplacedVehicles
    ]);

    const updatedVehicles = map(
      v =>
        assoc(
          "displacement",
          this.isVehicleDisplaced(v, displacedVehicles),
          assoc(
            "location",
            this.locationForVehicle(
              v,
              locations.data,
              itemLocations.data,
            ),
            v
          )
        ),
      vehicles.data
    );

    if (location === 0) {
      const dataOrder = sortWith(
        [
          ascend(path(["model", "order"])),
          ascend(path(["location", "screen_order"])),
          ascend(prop("id"))
        ],
        updatedVehicles
      );
      return dataOrder
    }
    else {
      const specialVehicles = filter(
        obj =>
          R.isNil(obj.location) &&
          obj.base_location.base_location_id === location,
        updatedVehicles
      );

      const vehiclesWithTransfers = filter(obj => {
        const sortedTransfers = sortBy(
          path(["transfer_date"]),
          filter(
            obj =>
              moment(obj.transfer_date).isSameOrBefore(endDate) &&
              moment(obj.transfer_date).isSameOrAfter(startDate),
            sortBy(path(["transfer_date"]), obj.transfers)
          )
        );

        return (
          (!R.isNil(obj.location) &&
            R.prop("id", obj.location) !== location &&
            !R.isEmpty(sortedTransfers) &&
            R.prop("location_id_1", R.head(sortedTransfers)) === location) ||
          R.prop("location_id_2", R.head(sortedTransfers)) === location
        );
      }, updatedVehicles);

      const locationVehicles = R.filter(
        vehicle => !isNil(find(propEq("id", location), prop("location", vehicle))),
        updatedVehicles
      );
    
      const finalList = sortBy(
        path(["model", "order"]),
        locationVehicles.concat(specialVehicles).concat(vehiclesWithTransfers)
      );

      return R.uniq(finalList);
    }
  }

  getRentalBlockColor(rental, start, end, day) {
    const halfDayColor = "#FFCC66";
    let baseBlockColor = "red";

    if (rental.from_agency || (rental.agency_id !== 2 && !R.isNil(rental.agency_id))) {
      baseBlockColor = "#FFFF00";
    }

    if (day.format("YYYY-MM-DD") === start.format("YYYY-MM-DD") && rental.time_1 === "18:00:00") {
      return halfDayColor;
    }

    if (day.format("YYYY-MM-DD") === end.format("YYYY-MM-DD") && rental.time_2 === "10:00:00") {
      return halfDayColor;
    }

    return baseBlockColor;
  }

  isVehicleDisplaced = (vehicle, displacedVehicles) => {
    const vehicleDisplaced = find(
      propEq("id", vehicle.id),
      displacedVehicles.data
    );
    return {
      displaced: vehicleDisplaced.displaced,
      displaceDate: vehicleDisplaced.displacedDate
    };
  };

  locationForVehicle = (vehicle, locations, itemLocations) => {
    // Known vehicle locations (given by events) in the selected time period
    const vehicleEventLocations = filter(propEq("item_id", vehicle.id), itemLocations);
    const vehicleEventLocationsIds = uniq(map(location => prop("location_id_2", location), vehicleEventLocations));
    // Get locations for the selected time period
    const vehicleLocations = filter(location => indexOf(prop("id", location), vehicleEventLocationsIds) > -1, locations)
    return vehicleLocations;
  };

  async setData() {
    const {
      date_start,
      date_end,
      location,
      model,
      op_date_begin,
      op_date_end
    } = parse(this.props.location.search);
    const startDate = moment(date_start);
    const endDate = moment(date_end);
    const opDateBegin = !isNil(op_date_begin) ? moment(op_date_begin) : null;
    const opDateEnd = !isNil(op_date_end) ? moment(op_date_end) : null;

    // const reloading = false;
    await this.updateState(
      startDate,
      endDate,
      Number(location),
      model,
      opDateBegin,
      opDateEnd
    );
  }

  setReload() {
    this.setState({ reloading: true });
  }

  async componentDidUpdate(prevProps) {
    if (this.props.location.search !== prevProps.location.search) {
      return await this.setData();
    }
  }

  async componentDidMount() {
    this.setData();
  }

  updateState = async (
    startDate,
    endDate,
    location,
    model,
    opDateBegin,
    opDateEnd
  ) => {
    const data = await this.fetchData(startDate, endDate, location, model);
    const models = await this.getModels();
    const locations = await this.getLocations();
    const holidays = await this.getHolidays(startDate, endDate, location);

    this.setState({
      reloading: false,
      data,
      startDate,
      endDate,
      location,
      model,
      models,
      holidays,
      locations: locations.data,
      opDateBegin,
      opDateEnd
    });
  };

  sortedDayList = (start, end, nextEventDate, forceAdd = false) => {
    const add = (day, offset) => day.clone().add(offset, "days");
    if (end.isSame(nextEventDate, "day")) {
      return map(
        curry(add)(start),
        range(0, end.startOf('day').diff(start.startOf('day'), "days") + (forceAdd ? 1 : 0))
      );
    }
    return map(curry(add)(start), range(0, end.startOf('day').diff(start.startOf('day'), "days") + 1));
  };

  blockForHoldEvent = (
    hold,
    vehicle,
    nextEvent,
    nextEventDate,
    startLimit,
    endLimit,
    opDateBegin,
    opDateEnd
  ) => {
    const start = moment.max(moment(hold.start_date), startLimit);

    const end = R.reduce(moment.min, moment(DISTANT_FUTURE), [
      moment(hold.end_date),
      endLimit,
      nilMap(moment, nextEventDate) || moment(DISTANT_FUTURE)
    ]);

    const days = this.sortedDayList(start, end, nextEventDate);

    const retirementDate = nilMap(moment, prop("retirement_date", vehicle));

    const isRetirement =
      retirementDate && retirementDate.isSame(hold.start_date, "day");

    const cell = day => {
      if (isRetirement) {
        return (
          <Cell
            extraText=""
            textValue={
              <React.Fragment>
                H: {this.buildLinkForHold(hold, vehicle.licence_plate)}
              </React.Fragment>
            }
            secundaryTextValue={
              <StyledMonetizationOn
                titleAccess={`Vans for Sale - ${moment(
                  vehicle.retirement_date
                ).format("YYYY-MM-DD")}`}
              />
            }
            color={"#FF00CC"}
            weekend={isWeekend(day) || this.isHoliday(day)}
            smallAux={true}
            style={{
              borderBottom: day.isSame(moment(opDateEnd))
                ? "3px dashed red"
                : "",
              borderTop: day.isSame(moment(opDateBegin)) ? "3px dashed red" : ""
            }}
          />
        );
      }
      return (
        <Cell
          extraText=""
          textValue={
            <React.Fragment>
              H: {this.buildLinkForHold(hold, vehicle.licence_plate)}
            </React.Fragment>
          }
          secundaryTextValue={"H"}
          color={"#FF00CC"}
          weekend={isWeekend(day)}
          smallAux={true}
          style={{
            borderBottom: day.isSame(moment(opDateEnd)) ? "3px dashed red" : "",
            borderTop: day.isSame(moment(opDateBegin)) ? "3px dashed red" : ""
          }}
        />
      );
    };
    let locat = null
    for (let index = 0; index < vehicle.location.length; index++) {
      locat = vehicle.location[index].location3letter_name;
    }
    return map(day => <Row id={hold.id} key={`${locat}_${vehicle.id}_${day}`}>{cell(day)}</Row>, days);
  };

  buildLinkTourRental = (rental, title) => {
    return (
      <StyledLink
        to={{
          pathname: `/${rental.type === 2 ? "rental_clients" : "tour_clients"
            }/${rental.id}/show`
        }}
        target="_blank"
      >
        {title}
      </StyledLink>
    );
  };

  buildLinkForTransfer = (tranfer, title) => {
    return (
      <StyledLink to={{ pathname: `/transfers/${tranfer.id}` }} target="_blank">
        {title}
      </StyledLink>
    );
  };

  buildLinkForHold = (hold, title) => {
    return (
      <StyledLink to={{ pathname: `/holds/${hold.id}` }} target="_blank">
        {title}
      </StyledLink>
    );
  };

  buildLinkForTourGuide = (tour, title) => {
    return (
      <StyledLink to={{ pathname: `/tours/${tour.id}` }} target="_blank">
        {title}
      </StyledLink>
    );
  };

  blockForRental = (
    rental,
    vehicle,
    nextEvent,
    nextEventDate,
    startLimit,
    endLimit,
    opDateBegin,
    opDateEnd
  ) => {

    const start = moment.max(moment(rental.date_1), startLimit);
    const end = moment.min(moment(rental.date_2), endLimit);
    const days = this.sortedDayList(start, end, nextEventDate, true);
    const overlapsWithNextEvent = (day) => moment(day).isSame(nextEventDate, 'day');

    if (overlapsWithNextEvent(end) && !R.isNil(nextEvent)) {
      nextEvent.skipFirstDay = true;
    }

    if (rental.skipFirstDay) {
      days.shift();
    }

    const isTour = R.propEq("type", 1);
    const driver = R.prop("driver", rental);
    const booking = R.prop("booking", rental);
    const country = R.prop("country", driver);

    const cell = day => {
      const isSameDayBegin =
        day.format("YYYY-MM-DD") === moment(opDateBegin).format("YYYY-MM-DD");
      const isSameDayEnd =
        day.format("YYYY-MM-DD") === moment(opDateEnd).format("YYYY-MM-DD");

      const displayNextRentalInformation = overlapsWithNextEvent(day);

      if (!isTour(rental)) {
        return (
          <Cell
            extraText=""
            textValue={
              <React.Fragment>
                R: {this.buildLinkTourRental(rental, rental.id)}{" "}
              </React.Fragment>
            }
            secundaryTextValue={
              <React.Fragment>
                {displayNextRentalInformation && <StyledError />}
                <RentalPopOver>
                  {booking.r_first_name} {booking.r_last_name}
                  {", "}
                  {prop("country", country)}
                  {", "}
                  {duration(rental)} days
                  {displayNextRentalInformation && (
                    <React.Fragment>
                      <br />
                      {"Next rental on this day:"}
                      <br />
                      {R.path(['booking', 'r_first_name'], nextEvent)} {R.path(['booking', 'r_last_name'], nextEvent)}
                      {", "}
                      {prop("country", country)}
                      {", "}
                      {R.isNil(nextEvent) ? 0 : duration(nextEvent)} days
                    </React.Fragment>

                  )}
                </RentalPopOver>
              </React.Fragment>
            }
            style={{
              borderBottom: isSameDayEnd ? "3px dashed red" : "",
              borderTop: isSameDayBegin ? "3px dashed red" : ""
            }}
            color={this.getRentalBlockColor(rental, start, end, day)}
            weekend={isWeekend(day) || this.isHoliday(day)}
            smallAux={!displayNextRentalInformation}
          ></Cell>
        );
      } else {
        return (
          <Cell
            extraText=""
            textValue={
              <React.Fragment>
                T: {this.buildLinkTourRental(rental, rental.id)}
              </React.Fragment>
            }
            secundaryTextValue={
              <RentalPopOver>
                **{" "}
                {path(["booking", "tour", "tour_name", "tour_name_en"], rental)}{" "}
                -- {moment(rental.date_1).format("MMM")}{" "}
                {moment(rental.date_1).format("DD")}-
                {moment(rental.date_2).format("DD")}{" "}
                {moment(rental.date_2).format("YYYY")} **{" "}
                {booking.r_first_name} {booking.r_last_name}
                {", "}
                {prop("country", country)}
                {", "}
              </RentalPopOver>
            }
            style={{
              borderBottom: isSameDayEnd ? "3px dashed red" : "",
              borderTop: isSameDayBegin ? "3px dashed red" : ""
            }}
            color={"#CC9999"}
            weekend={isWeekend(day) || this.isHoliday(day)}
            smallAux={true}
          />
        );
      }
    };
    let locat = null
    for (let index = 0; index < vehicle.location.length; index++) {
      locat = vehicle.location[index].location3letter_name;
    }
    return map(day => <Row id={rental.id} key={`${locat}_${vehicle.id}_${day}`} >{cell(day)}</Row>, days);
  };

  blockForTransfer = (
    transfer,
    vehicle,
    nextEvent,
    nextEventDate,
    startLimit,
    endLimit,
    opDateBegin,
    opDateEnd
  ) => {
    const start = moment.max(moment(transfer.transfer_date), startLimit);
    const end = moment.min(moment(transfer.setup_date), endLimit);

    const days = this.sortedDayList(start, end, nextEventDate);

    return map(day => {
      const isSameDayBegin =
        day.format("YYYY-MM-DD") === moment(opDateBegin).format("YYYY-MM-DD");
      const isSameDayEnd =
        day.format("YYYY-MM-DD") === moment(opDateEnd).format("YYYY-MM-DD");
      let locat = null
      for (let index = 0; index < vehicle.location.length; index++) {
        locat = vehicle.location[index].location3letter_name;
      }
      return (
        <Row id={transfer.id} key={`${locat}_${vehicle.id}_${day}`}>
          <Cell
            extraText=""
            textValue={
              <React.Fragment>
                Transfer: {this.buildLinkForTransfer(transfer, transfer.id)}
              </React.Fragment>
            }
            secundaryTextValue={<RentalPopOver>{transfer.notes}</RentalPopOver>}
            color={"#9966FF"}
            weekend={isWeekend(day) || this.isHoliday(day)}
            smallAux={true}
            style={{
              borderBottom: isSameDayEnd ? "3px dashed red" : "",
              borderTop: isSameDayBegin ? "3px dashed red" : ""
            }}
          />
        </Row>
      );
    }, days);
  };

  blockForGuideTour = (
    tour,
    vehicle,
    nextEvent,
    nextEventDate,
    startLimit,
    endLimit,
    description,
    opDateBegin,
    opDateEnd
  ) => {
    const start = moment.max(moment(tour.effective_start_date), startLimit);
    const end = moment.min(moment(tour.effective_end_date), endLimit);

    const days = this.sortedDayList(start, end, nextEventDate);

    return map(day => {
      const isSameDayBegin =
        day.format("YYYY-MM-DD") === moment(opDateBegin).format("YYYY-MM-DD");
      const isSameDayEnd =
        day.format("YYYY-MM-DD") === moment(opDateEnd).format("YYYY-MM-DD");
      let locat = null
      for (let index = 0; index < vehicle.location.length; index++) {
        locat = vehicle.location[index].location3letter_name;
      }
      return (
        <Row id={tour.id} key={`${locat}_${vehicle.id}_${day}`}>
          <Cell
            extraText=""
            textValue={
              <React.Fragment>
                {description}: {this.buildLinkForTourGuide(tour, tour.id)}
              </React.Fragment>
            }
            secundaryTextValue={
              <RentalPopOver>
                ** {path(["tour_name", "tour_name_en"], tour)} --{" "}
                {moment(tour.effective_start_date).format("MMM")}{" "}
                {moment(tour.effective_start_date).format("DD")}-
                {moment(tour.effective_end_date).format("DD")}{" "}
                {moment(tour.effective_end_date).format("YYYY")} **{" "}
                {description}
              </RentalPopOver>
            }
            color={"#66CCFF"}
            weekend={isWeekend(day) || this.isHoliday(day)}
            smallAux={true}
            style={{
              borderBottom: isSameDayEnd ? "3px dashed red" : "",
              borderTop: isSameDayBegin ? "3px dashed red" : ""
            }}
          />
        </Row>
      );
    }, days);
  };

  daysForEvent = (
    { event, type },
    vehicle,
    nextEvent,
    nextEventDate,
    start,
    end,
    opDateBegin,
    opDateEnd
  ) => {
    switch (type) {
      case "hold":
        return this.blockForHoldEvent(
          event,
          vehicle,
          nextEvent,
          nextEventDate,
          start,
          end,
          opDateBegin,
          opDateEnd
        );
      case "transfer":
        return this.blockForTransfer(
          event,
          vehicle,
          nextEvent,
          nextEventDate,
          start,
          end,
          opDateBegin,
          opDateEnd
        );
      case "rental":
        return this.blockForRental(
          event,
          vehicle,
          nextEvent,
          nextEventDate,
          start,
          end,
          opDateBegin,
          opDateEnd
        );
      case "guide_tour_bike":
        return this.blockForGuideTour(
          event,
          vehicle,
          nextEvent,
          nextEventDate,
          start,
          end,
          "Guide",
          opDateBegin,
          opDateEnd
        );
      case "guide_tour_van":
        return this.blockForGuideTour(
          event,
          vehicle,
          nextEvent,
          nextEventDate,
          start,
          end,
          "Vans tour",
          opDateBegin,
          opDateEnd
        );
      default:
        return this.blockForRental(
          event,
          vehicle,
          nextEvent,
          nextEventDate,
          start,
          end,
          opDateBegin,
          opDateEnd
        );
    }
  };

  locationForEvent = ({ event, type }) => {
    switch (type) {
      case "hold":
        return null;
      case "transfer":
        return event.location_2;
      case "rental":
        return event.location_2;
      case "guide_tour_bike":
        return event.location_2;
      case "guide_tour_van":
        return event.location_2;
      default:
        return event.location_2;
    }
  };

  bikeAtBase = (
    vehicle,
    prevEventDate,
    nextEventDate,
    location,
    startLimit,
    endLimit,
    opDateBegin,
    opDateEnd
  ) => {
    const start = moment.max(
      moment(prevEventDate || DISTANT_PAST).add(1, "day"),
      startLimit
    );
    const end = moment.min(
      moment(nextEventDate || DISTANT_FUTURE).add(-1, "day"),
      endLimit
    );

    const days = this.sortedDayList(start, end, nextEventDate, true);

    const cell = day => {
      const isSameDayBegin =
        day.format("YYYY-MM-DD") === moment(opDateBegin).format("YYYY-MM-DD");
      const isSameDayEnd =
        day.format("YYYY-MM-DD") === moment(opDateEnd).format("YYYY-MM-DD");
      return (
        <Cell
          extraText=""
          textValue={
            <React.Fragment>
              {vehicle.licence_plate}{" "}
              {vehicle.renting && <SpanRented>&#9415;</SpanRented>}
            </React.Fragment>
          }
          secundaryTextValue={
            !isNil(vehicle.retirement_date) &&
              moment(vehicle.retirement_date).isSameOrBefore(moment()) ? (
              <StyledMonetizationOn
                titleAccess={`Vans for Sale - ${moment(
                  vehicle.retirement_date
                ).format("YYYY-MM-DD")}`}
              />
            ) : (
              `${R.prop("location3letter_name", location)}`
            )
          }
          color={"#99FF99"}
          secundaryColor={R.prop("color", location)}
          weekend={isWeekend(day) || this.isHoliday(day)}
          smallAux={true}
          style={{
            borderBottom: isSameDayEnd ? "3px dashed red" : "",
            borderTop: isSameDayBegin ? "3px dashed red" : ""
          }}
        />
      );
    };
    let locat = null
    for (let index = 0; index < vehicle.location.length; index++) {
      locat = vehicle.location[index].location3letter_name;
    }
    return map(day => <Row id={vehicle.id} key={`${locat}_${vehicle.id}_${day}`}>{cell(day)}</Row>, days);
  };

  isHoliday = day => {
    const { holidays } = this.state;
    const hasHollidays = [];
    map(hd => {
      if (moment(hd.date).format("YYYY-MM-DD") === day.format("YYYY-MM-DD")) {
        hasHollidays.push(hd);
      }
    }, prop("data", holidays));
    return R.length(hasHollidays) > 0;
  };

  buildTimeline = (start, end, opDateBegin, opDateEnd) => {
    const days = this.sortedDayList(start, end);
    const rows = map(day => {
      return (
        <Row
          id={`${start.unix()}_${Math.random()}`}
          key={`${start.unix()}_${Math.random()}`}
        >
          <WeekDay
            key={`d_${day.format("dddd")}_${Math.random()}`}
            style={{
              borderBottom: day.isSame(moment(opDateEnd))
                ? "3px dashed red"
                : "",
              borderTop: day.isSame(moment(opDateBegin))
                ? "3px dashed red"
                : "",
              color: isWeekend(day) || this.isHoliday(day) ? "red" : null
            }}
          >
            {day.format("dddd")}
          </WeekDay>
          <Date
            style={{
              color: isWeekend(day) || this.isHoliday(day) ? "red" : null,
              borderBottom: day.isSame(moment(opDateEnd))
                ? "3px dashed red"
                : "",
              borderTop: day.isSame(moment(opDateBegin)) ? "3px dashed red" : ""
            }}
          >
            {day.format("DD-MM-YYYY")}
          </Date>
        </Row>
      );
    }, days);

    return <DateColumn>{rows}</DateColumn>;
  };

  buildEvents = (vehicles, start, end, opDateBegin, opDateEnd, location) => {

    const locat = ['MAD', 'BAR', 'MAL', 'LIS', 'BIL'];
    const orden_modelo = ['Citroen Jumper'];

    const SortVehicleLocation = arr => {
      let newArray = [];

      arr.sort((left, right) => {
        return moment.utc(left.purchase_date).diff(moment.utc(right.purchase_date));
      });

      if (location === 0) {
        locat.forEach(base => {
          orden_modelo.forEach(modelo => {
            arr.forEach(data => { //ordenando por ubicaciones
              if (base === data.location[0].location3letter_name && modelo === data.model.model_name) {
                newArray.push(data)
              }
            });
          });
        });
      } else {
        orden_modelo.forEach(modelo => {
          arr.forEach(data => { //ordenando por ubicaciones
            if (modelo === data.model.model_name) {
              newArray.push(data)
            }
          });
        });
      }

      return newArray;
    };

    const result = SortVehicleLocation(vehicles);
    return map(
      curry(
        this.buildEventsForVehicle
      )
        (start, end, opDateBegin, opDateEnd),
      result
    );
  };

  buildEventsForVehicle = (
    startLimit,
    endLimit,
    opDateBegin,
    opDateEnd,
    vehicle
  ) => {
    // abstracts events in a boxed record for easier sorting since date props have diferent keys, startDate and endDate functions returns the start date and end date for a given box
    const buildEventRecords = (events, type, startKey, endKey) =>
      map(event => ({ type, event, startKey, endKey }), events);
    const startDate = R.converge(R.prop, [R.prop("startKey"), R.prop("event")]);
    const endDate = R.converge(R.prop, [R.prop("endKey"), R.prop("event")]);
    const events = R.unnest([
      buildEventRecords(
        vehicle.transfers || [],
        "transfer",
        "transfer_date",
        "setup_date"
      ),
      buildEventRecords(vehicle.rentals || [], "rental", "date_1", "date_2"),
      buildEventRecords(vehicle.holds || [], "hold", "start_date", "end_date"),
      buildEventRecords(
        vehicle.tours || [],
        "guide_tour_bike",
        "effective_start_date",
        "effective_end_date"
      ),
      buildEventRecords(
        vehicle.van_tours || [],
        "guide_tour_van",
        "effective_start_date",
        "effective_end_date"
      )
    ]);
    const sortedEvents = R.sortBy(startDate, events);
    const eventsTuples = R.concat(
      R.aperture(2, sortedEvents),
      R.filter(R.identity, [nilMap(e => [e, null], R.last(sortedEvents))])
    );

    const firstEventDate = nilMap(
      moment,
      nilMap(startDate, R.head(sortedEvents))
    );

    const initialEvents = (() => {
      if (R.isNil(firstEventDate) || firstEventDate.isAfter(startLimit)) {
        return this.bikeAtBase(
          vehicle,
          undefined,
          firstEventDate,
          vehicle.location,
          startLimit,
          endLimit,
          opDateBegin,
          opDateEnd
        );
      }
      return [];
    })();

    const [_, eventsBlocks] = R.mapAccum(
      (location, [event, next]) => {
        const nextEventDate = nilMap(startDate)(next);
        const lastLocation = nilMap(this.locationForEvent)(event) || location;

        const daysForEvent = this.daysForEvent(
          event,
          vehicle,
          R.prop('event', next),
          nextEventDate,
          startLimit,
          endLimit,
          opDateBegin,
          opDateEnd
        );
        const daysForBase = this.bikeAtBase(
          vehicle,
          endDate(event),
          nextEventDate,
          lastLocation || {},
          startLimit,
          endLimit,
          opDateBegin,
          opDateEnd
        );

        const r = R.unnest([daysForEvent, daysForBase]);
        return [lastLocation, r];
      },
      vehicle.location,
      eventsTuples
    );

    const cells = R.concat(initialEvents, R.unnest(eventsBlocks));
    const firstRow = R.head(cells);
    const secondRow = R.compose(R.head, R.tail)(cells);

    const shouldDisplayWarning = () => {
      return vehicle.displacement.displaced;
    };

    const newFirstRow = (
      <firstRow.type id={firstRow.props.id} key={`${firstRow.props.children.props.secundaryTextValue}_${firstRow.props.id}_t1-${vehicle.licence_plate}`} >
        <firstRow.props.children.type
          {...firstRow.props.children.props}
          extraText=""
          textValue={`${vehicle.model.model_name.replace("Citroen", "")}${vehicle.low ? "-L" : ""
            }`}
          secundaryTextValue={firstRow.props.children.props.secundaryTextValue}
          textColor={"blue"}
          textWeight={"bold"}
        >
          {shouldDisplayWarning() ? <StyledError /> : ""}
        </firstRow.props.children.type>
      </firstRow.type>
    );

    const newSecondRow = (
      <secondRow.type id={secondRow.props.id} key={`${secondRow.props.children.props.secundaryTextValue}_${secondRow.props.id}_t2-${vehicle.licence_plate}`}>
        <secondRow.props.children.type
          {...secondRow.props.children.props}
          extraText=""
          textValue={`${vehicle.vehicle_mileage}km`}
          textColor={"red"}
          textWeight={"bold"}
        />
      </secondRow.type>
    );

    const cells2 = R.unnest([
      [newFirstRow],
      [newSecondRow],
      R.compose(R.tail, R.tail)(cells)
    ]);

    let elements = [];
    let cont = 1;
    cells2.forEach(element => {
      if (cont % 20 === 0) {
        const kms = path(
          ["props", "children", "props", "textValue"],
          newSecondRow
        );
        const model = path(
          ["props", "children", "props", "textValue"],
          newFirstRow
        );

        const newElement = React.cloneElement(element, ...element.props, {
          children: {
            ...element.props.children,
            props: {
              ...element.props.children.props,
              extraText: `${model} - ${kms}`
            }
          }
        });

        elements.push(newElement);
      } else {
        elements.push(element);
      }
      cont += 1;
    });

    let locat = null
    for (let index = 0; index < vehicle.location.length; index++) {
      locat = vehicle.location[index].location3letter_name;
    }
    return <Column key={`${locat}_${vehicle.id}_${vehicle.licence_plate}`}> {elements} </Column>;
  };

  render() {
    if (this.state === null || (this.state !== null && this.state.reloading)) {
      return (
        <Card>
          <LinearProgress />
        </Card>
      );
    }

    const timeline = this.buildTimeline(
      this.state.startDate,
      this.state.endDate,
      this.state.opDateBegin,
      this.state.opDateEnd
    );
    const events = this.buildEvents(
      this.state.data,
      this.state.startDate,
      this.state.endDate,
      this.state.opDateBegin,
      this.state.opDateEnd,
      this.state.location
    );
    const {
      model,
      startDate,
      endDate,
      models,
      locations,
      location,
      opDateBegin,
      opDateEnd
    } = this.state;

    const withModel = prop(
      "model_name",
      head(filter(propEq("id", parseInt(model, 0)), models))
    );

    const withLocation = prop(
      "location_name",
      head(filter(propEq("id", parseInt(location, 0)), locations))
    );

    return (
      <Card style={{ textAlign: "center" }}>
        <CardHeader
          title={`MOTO SCHEDULE (${model !== "0" ? withModel : "ALL MODELS"
            }) - ${location !== 0 ? withLocation.toUpperCase() : "ALL LOCATIONS"
            }`}
        />
        <CardContent>
          <BackButton>
            <Button
              size="small"
              color="primary"
              component={Link}
              to={{
                pathname: `/vans_schedule/start`,
                search: `?date_start=${startDate.format(
                  "YYYYMMDD"
                )}&date_end=${endDate.format(
                  "YYYYMMDD"
                )}&location=${location}&model=1&op_date_begin=${opDateBegin.isValid() ? opDateBegin.format("YYYYMMDD") : null
                  }&op_date_end=${opDateEnd.isValid() ? opDateEnd.format("YYYYMMDD") : null
                  }`
              }}
            >
              Pick a different model/city/time period
            </Button>
          </BackButton>
          <BackButton>
            <Button
              size="small"
              color="primary"
              component={Link}
              title="Back one month"
              onClick={() => this.setReload()}
              to={{
                pathname: `/vans_schedule`,
                search: `?date_start=${startDate
                  .subtract(1, "month")
                  .format("YYYYMMDD")}&date_end=${endDate
                    .subtract(1, "month")
                    .format(
                      "YYYYMMDD"
                    )}&location=${location}&model=1&op_date_begin=${opDateBegin.isValid()
                      ? opDateBegin.subtract(1, "month").format("YYYYMMDD")
                      : null
                  }&op_date_end=${opDateEnd.isValid()
                    ? opDateEnd.subtract(1, "month").format("YYYYMMDD")
                    : null
                  }`
              }}
            >
              <ArrowUpward />
            </Button>
          </BackButton>
          <Grid>
            {timeline}
            <Table>{events}</Table>
          </Grid>
        </CardContent>
      </Card>
    );
  }
}

export default VansSchedule;



// WEBPACK FOOTER //
// ./src/components/vansSchedule.js